module.exports = __webpack_public_path__ + "img/share-task-guest.b10ac147.svg";